import ClosedSign from '@assets/Svg/closed-sign.svg';
import { Button, Text, View } from '@components/primitives';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dimensions, Platform, BackHandler } from 'react-native';

const { width } = Dimensions.get('window');

const DowntimeScreen = () => {
  const { t } = useTranslation('common');

  const closeApp = () => {
    if (Platform.OS !== 'web') {
      BackHandler.exitApp();
    }
  };
  return (
    <View flex={1} justifyContent="center" alignContent="center">
      <ClosedSign width={width} height={width * (640 / 800)} />
      <View alignContent="center" justifyContent="center" padding={5}>
        <Text variant="lg-normal" textAlign="center" marginBottom={5}>
          {t('common.maintenanceText')}
        </Text>
        {Platform.OS !== 'web' && (
          <View alignContent="center" justifyContent="center" marginY={15}>
            <Button
              size="lg"
              textColor={colors.neutral.cotton}
              variant="solid"
              onPress={closeApp}
              color="red"
              marginX={scale(5)}
              paddingY={scale(8)}>
              {t('common.closeApp')}
            </Button>
          </View>
        )}
      </View>
    </View>
  );
};

export default DowntimeScreen;
